// extracted by mini-css-extract-plugin
export default {"container":"CopyButton_container__kqHSk","successText":"CopyButton_successText__0VcO0","copyIcon":"CopyButton_copyIcon__6uVan","disabled":"CopyButton_disabled__S7ZUw"};